/*
 * fof/discussion-thumbnail na lista do tema.
 *
 * A extensão troca o avatar do autor pela miniatura, mas a lista do tema
 * nem desenha esse avatar (os postadores ficam numa coluna).
 * Então a miniatura vira um item próprio, antes do título; no celular ela ocupa o lugar do
 * avatar de 48px.
 */
import app from 'flarum/forum/app';
import { extend } from 'flarum/common/extend';
import Link from 'flarum/common/components/Link';
import DiscussionListItem from 'flarum/forum/components/DiscussionListItem';
import { thirdParty } from './settings';
export default function installThumbnails() {
  extend(DiscussionListItem.prototype, 'contentItems', function (items) {
    if (!thirdParty.thumbnails()) return;

    // Os resultados do modal de busca (MinimalDiscussionListItem) continuam com o avatar.
    if (String(this.elementAttrs().className || '').includes('MinimalDiscussionListItem')) return;
    const discussion = this.attrs.discussion;
    const src = discussion.attribute('customThumbnail');
    if (!src) return;
    items.add('canelaThumbnail', m(Link, {
      href: app.route.discussion(discussion),
      className: "CanelaTopicThumbnail",
      tabindex: "-1",
      "aria-hidden": "true"
    }, m("img", {
      src: src,
      alt: "",
      loading: "lazy",
      decoding: "async"
    })), 90);
  });
}
flarum.reg.add('ramon-canela', 'forum/thirdparty/thumbnails', installThumbnails);